// SPEC-PATROL-SWIPE-LATENCY-FIX-03: module-level in-memory hold for synced baseline prev.
// Mirrors swipeTransition.js pattern: module-level, router/sessionStorage avoided.
// tier-0 prev cache: microsecond reads vs IDB milliseconds, zero Supabase per swipe.
//
// Store-scoped: setPrevHold replaces the entire map on store entry (one store at a time).
// clearPrevHold on store exit. Only synced baseline held — unsynced edits remain tier-1 (IDB).
// IDB baseline stays source of truth; hold is a fast read layer only. No writes go through hold.

let _currentStoreCode = null
let _holdMap = new Map()  // boothCode -> prev row

export function setPrevHold(storeCode, boothToPrevMap) {
  _currentStoreCode = storeCode
  _holdMap = new Map(Object.entries(boothToPrevMap))
}

export function getPrevHold(boothCode) {
  return _holdMap.get(boothCode) ?? null
}

// SPEC-PATROL-PREV-HOLD-INVALIDATE-ON-WRITE-01 (D-235): 書き込み時のキャッシュ無効化。
//   当該ブースのローカル行が書かれた/同期成功で synced 化した瞬間、この tier-0 hold が古い値を返し続ける
//   のを防ぐため、当該キーのみ delete する。表全体・_currentStoreCode・他の関数の既存挙動は変えない。
//   次に当該ブースを開くと下位 tier-2(端末 DB=真実)へ落ちて正しい prev が buildPrevFromRows で再合成される。
export function invalidatePrevHold(boothCode) {
  if (boothCode == null || boothCode === '') return
  if (!_holdMap.has(boothCode)) return
  _holdMap.delete(boothCode)
}

export function clearPrevHold(storeCode) {
  if (storeCode == null || storeCode === _currentStoreCode) {
    _currentStoreCode = null
    _holdMap = new Map()
  }
}

export function _resetPrevHold() {
  _currentStoreCode = null
  _holdMap = new Map()
}
